import React from 'react';
import {useTranslation} from '../../../config/TranslationProvider';

const FulltextInput = ({register, selected = ''}) => (
    <input
        type="text"
        name="fulltext"
        id="fulltextSearch"
        className="form-control"
        ref={register}
        defaultValue={selected}
        placeholder={useTranslation('search_placeholder')}
        aria-label="text"
    />
);

export default FulltextInput;
